import { useState } from "react";
import ModalWindow from "../../../../../../Components/ModalWindow/ModalWindow";
import CheckBox from "../../../../../../Components/CheckBox/CheckBox";
import UsersRequests from "../../../../../../Services/Api/UserRequests.ts";

const AddEditUser = ({editData, setShow, refresh}) => {
    const usersRequests = new UsersRequests;

    const [login, setLogin] = useState(editData?.login);
    const [email, setEmail] = useState(editData?.email);
    const [discordId, setDiscordId] = useState(editData?.discordId);
    const [steamId64, setSteamId] = useState(editData?.steamId64);
    const [permissions, setPermissions] = useState(editData ? editData.permissions : 0);

    const addEdit = () => {
        const data = {
            login: login,
            email: email,
            steamId64: steamId64,
            permissions: permissions,
            discordId: discordId,
        }

        if(editData){
            data.id = editData.id;
            usersRequests.Edit(data, () => {setShow(false); refresh()});
        }
        else{
            usersRequests.Add(data, () => {setShow(false); refresh()});
        }
            
    }

    return (
        <ModalWindow 
            title={editData ? "Edycja użytkownika" : "Dodaj użytkownika"}
            minWidth={"40%"}
            buttons={[
                { Text: editData ? "Edytuj" : "Dodaj", onClick: () => addEdit() }, 
                { Text: "Anuluj", onClick: () => setShow(false), className: "modalSecondaryBtn" }, 
            ]}
            content={
                <>
                    <h3>Dane</h3>
                    { !editData && 
                        <div className="modalField">
                            <span className="pl-1">Login</span>
                            <input defaultValue={login} onChange={(e) => setLogin(e.target.value)}  className="input" type="text"></input>
                        </div>
                    }
                    { editData &&
                        <div className="modalField">
                            <p className="pl-1 mb-2">
                                <span className="text-glwhite-600">Użytkownik:</span> {login}
                            </p>
                        </div>
                    }
                    <div className="modalField">
                        <span className="pl-1">Email</span>
                        <input defaultValue={email} onChange={(e) => setEmail(e.target.value)}  className="input" type="text"></input>
                    </div>

                    <h3 className="mt-4">Integracja</h3>
                    <div className="modalField">
                        <span className="pl-1">SteamID64</span>
                        <input defaultValue={steamId64} onChange={(e) => setSteamId(e.target.value)}  className="input" type="text"></input>
                    </div> 
                    <div className="modalField">
                        <span className="pl-1">Discord Id</span>
                        <input defaultValue={discordId} onChange={(e) => setDiscordId(e.target.value)}  className="input" type="text"></input>
                    </div> 

                    <h3 className="mt-4">Uprawnienia</h3>
                    <div className="modalField">
                        <CheckBox 
                            value={permissions == 2} 
                            text="Admin"
                            onChange={() => setPermissions(permissions == 0 ? 2 : 0)}  
                        />
                    </div>                   
                </>
            }
        />
    )
}

export default AddEditUser;